export default __webpack_public_path__ + "static/media/kks.cbff6ef2.webp";